import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  Grid,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ToastPopup from "../ToastPopup";
import { goBack } from "../../Redux/Actions/InputData";



function CGOCreateFolder(props: any) {
  //const [isFolderExisted, setisFolderExisted] = React.useState(false);
  const isFolderExisted = useSelector(
    (state: any) => state.InputDataReducers.isFolderExisted
  );
  const [isNext, setIsNext] = React.useState(false);
  const [scenarioValue, setScenarioValue] = React.useState("");
  const [folderValue, setFolderValue] = React.useState("");

  const dispatch: any = useDispatch();


  const handleGoBack = () => {
    dispatch(goBack());
    setIsNext(false);
  };

  const handleScenario = (val: any) => {
    setScenarioValue(val.target.value);
  }
  const handleCreateNewFolder = () => {
    props.handleCreateNewFolder();
    props.getNewFolderData({scenarioValue:scenarioValue, folderValue:folderValue})
  }
  return (
    <>
      <DialogContent className="modal-body">
        <div className="create-folder">
          <div>
            <label>Folder name*</label>
            <TextField
              id="outlined-basic"
              placeholder="Enter Folder name"
              className="create-folder-text"
              variant="outlined"
              value={folderValue}
              onChange={(e) => setFolderValue(e.target.value)}
            />
          </div>
          <FormControl fullWidth>
            <label>
              Scenario Name* <InfoIcon className="info-Icon" />
            </label>
            <TextField
              id="outlined-basic"
              placeholder="Enter Scenario name"
              className="create-folder-text"
              variant="outlined"
              value={scenarioValue}
              onChange={handleScenario}
            />
          </FormControl>
        </div>
        {isFolderExisted && (
          <ToastPopup message={'Folder is existed'} type="error" />
        )}
     
      </DialogContent>
      <DialogActions>
        <div className="modal-action">
          <Button
            variant="outlined"
            className="cancel"
            onClick={handleGoBack}
          >
            Go Back
          </Button>

          <Button
            variant="contained"
            className="Create-new-folder"
            onClick={handleCreateNewFolder}
            disabled={scenarioValue === "" || folderValue === ""}
          >
            Create new folder
          </Button>
        </div>
      </DialogActions>
    </>
  );
}

export default CGOCreateFolder;
